import React, { useEffect, useState } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import { Button } from "@progress/kendo-react-buttons";
import { filterBy } from "@progress/kendo-data-query";

import "./Qualification.scss";

function QualificationDropdowns({ ddData, onSearchClick }) {
  const [carrierList, setCarrierList] = useState(ddData["carrier"]);
  const [originGeoList, setOriginGeoList] = useState(ddData["originDestgeoData"]);
  const [originPortList, setOriginPortList] = useState(ddData["originDestPortData"]);
  const [originCountryList, setOriginCountryList] = useState(ddData["originDestCountryData"]);
  const [destinationGeoList, setDestinationGeoList] = useState(ddData["originDestgeoData"]);
  const [destinationPortList, setDestinationPortList] = useState(ddData["originDestPortData"]);
  const [destinationCountryList, setDestinationCountryList] = useState(ddData["originDestCountryData"]);
  const [serviceTypeList, setServiceTypeList] = useState(ddData["serviceType"]);
  const [serviceLevelList, setServiceLevelList] = useState(ddData["serviceLevel"]);
  const [PrimaryOwnerList, setPrimaryOwnerList] = useState(ddData["primaryOwner"]);
  const [modeList, setModeList] = useState(ddData["mode"]);

  //for setting for default values
  const ddDefaultValues = {
    carrier: { value: "all", text: "Select SCAC..." },
    serviceType: {
      value: "all",
      text: "ALL",
      valueText: "Select Commodity...",
    },
    serviceLevel: {
      value: "",
      text: "ALL",
      valueText: "Select Service Level...",
    },
    mode: {
      value: "99",
      text: "All Modes",
      valueText: "Select Mode...",
    },
    primaryOwner: { value: "", text: "Select Primary Owner..." },
    originGeo: { value: "", text: "Select Origin Geo..."},
    originValue: { value: "", text: "Select Origin Port...", displayText: "Select Origin Port..."},
    originCountry: { value: "", text: "Select Origin Country..."},
    destinationGeo: { value: "", text: "Select Destination Geo..."},
    destinationValue: { value: "", text: "Select Destination Port...", displayText: "Select Destination Port..."},
    destCountry: { value: "", text: "Select Destination Country..."},
  };

  
  const [ddValues, setDdValues] = useState({
    carrier: { value: "all", text: "Select SCAC..." },
    serviceType: {
      value: "all",
      text: "ALL",
      valueText: "Select Commodity...",
    },
    serviceLevel: {
      value: "",
      text: "ALL",
      valueText: "Select Service Level...",
    },
    mode: {
      value: "99",
      text: "All Modes",
      valueText: "Select Mode...",
    },
    primaryOwner: { value: "", text: "Select Primary Owner..." },
    originGeo: { value: "", text: "Select Origin Geo..."},
    originValue: { value: "", text: "Select Origin Port...", displayText: "Select Origin Port..."},
    originCountry: { value: "", text: "Select Origin Country..."},
    destinationGeo: { value: "", text: "Select Destination Geo..."},
    destinationValue: { value: "", text: "Select Destination Port...", displayText: "Select Destination Port..."},
    destCountry: { value: "", text: "Select Destination Country..."},
  });

  useEffect(() => {
    console.log({ ddData });
  }, []);

  function filterData(filter, key) {
    const data = ddData[key].slice();
    return filterBy(data, filter);
  }

  function filterOriginData(filter) {
    let arr = ddData["originDestination"].map(
      (data) => data[ddValues["originGeo"].toLowerCase()]
    );
    const data = arr.slice();
    return filterBy(data, filter);
  }

  function filterDestinationData(filter) {
    let arr = ddData["originDestination"].map(
      (data) => data[ddValues["destinationGeo"].toLowerCase()]
    );
    const data = arr.slice();
    return filterBy(data, filter);
  }

  const ddPortChange = (eventObject, key) => {
    let dropDownValues = Object.assign( {...ddValues}, {[key]: eventObject} );
    let _tempData = [];

    if(eventObject.value == ""){
     (key == 'originValue')? setOriginPortList(ddData["originDestPortData"]) : setDestinationPortList(ddData["originDestPortData"]);
    } else {
      ddData["originDestination"].map(res => {
        if(res.port === eventObject.text){
          _tempData.push(res);
        }
      }
      );

    let _geo = [];
    let _country = [];

    _tempData.map(gcp =>{
      if (!_geo.find((element) => element.text == gcp.geo)){
        _geo.push({text: gcp.geo, value: gcp.geo})
      }
      if (!_country.find((element) => element.text == gcp.country)){
        _country.push({text: gcp.country, value: gcp.country.split('-')[0]})
      }
    })

    _geo = [...new Set(_geo)];
    _country = [...new Set(_country)];
    
    if(key == 'originValue'){
      setOriginGeoList(_geo);
      setOriginCountryList(_country);

      if(_geo.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originGeo: _geo[0] });

      if(_country.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originCountry:  _country[0] });

    } else if(key == 'destinationValue') {
      setDestinationGeoList(_geo);
      setDestinationCountryList(_country);

      if(_geo.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destinationGeo: _geo[0] });

      if(_country.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destCountry:  _country[0] });
    }
  }
  setDdValues({ ...dropDownValues });
  };

  const ddCountryChange = (eventObject, key) => {
    let dropDownValues = Object.assign( {...ddValues}, {[key]: eventObject} );
    let _tempData = [];

    if(eventObject.value == ""){
      (key == 'originCountry')? setOriginCountryList(ddData["originDestCountryData"]) : setDestinationCountryList(ddData["originDestCountryData"]);
     } else {
    ddData["originDestination"].map(res => {
        if(res.country === eventObject.text){
          _tempData.push(res);
        }
      }
    );

    let _geo = [];
    let _port = [];

    _tempData.map(gcp =>{
      if (!_geo.find((element) => element.text == gcp.geo)){
        _geo.push({text: gcp.geo, value: gcp.geo})
      }
      if (!_port.find((element) => element.text == gcp.port)){
        _port.push({text: gcp.port, value: gcp.port.split('-')[0].split('_')[1], displayText: gcp.port.split('_')[1]})
      }
    })

    _geo = [...new Set(_geo)];
    _port = [...new Set(_port)];

    if(key == 'originCountry'){
      setOriginGeoList(_geo);
      setOriginPortList(_port);

      if(_geo.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originGeo: _geo[0] });

      if(_port.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originValue:  _port[0] });
      else
      dropDownValues = Object.assign( dropDownValues, { originValue:  { value: "", text: "Select Origin Port...", displayText: "Select Origin Port..."} });

    } else if(key == 'destCountry') {
      setDestinationGeoList(_geo);
      setDestinationPortList(_port);

      if(_geo.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destinationGeo: _geo[0] });

      if(_port.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destinationValue:  _port[0] });
      else
      dropDownValues = Object.assign( dropDownValues, { destinationValue: { value: "", text: "Select Destination Port...", displayText: "Select Destination Port..."} });
    }
  }
    setDdValues({ ...dropDownValues });
  };

  const ddGeoChange = (eventObject, key) => {
    let dropDownValues = Object.assign( {...ddValues}, {[key]: eventObject} );
    let _tempData = [];

    if(eventObject.value == ""){
      (key == 'originGeo')? setOriginGeoList(ddData["originDestgeoData"]) : setDestinationGeoList(ddData["originDestgeoData"]);
     } else {
    ddData["originDestination"].map(res => {
        if(res.geo === eventObject.text){
          _tempData.push(res);
        }
      }
    );

    let _country = [];
    let _port = [];

    _tempData.map(gcp =>{
      if (!_country.find((element) => element.text == gcp.country)){
        _country.push({text: gcp.country, value: gcp.country.split('-')[0]})
      }
      if (!_port.find((element) => element.text == gcp.port)){
        _port.push({text: gcp.port, value: gcp.port.split('-')[0].split('_')[1], displayText: gcp.port.split('_')[1]})
      }
    })

    _country = [...new Set(_country)];
    _port = [...new Set(_port)];

    if(key == 'originGeo'){
      setOriginCountryList(_country);
      setOriginPortList(_port);

      if(_country.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originCountry:  _country[0] });

      if(_port.length == 1)
      dropDownValues = Object.assign( dropDownValues, { originValue:  _port[0] });
    } else if(key == 'destinationGeo'){
      setDestinationCountryList(_country);
      setDestinationPortList(_port);

      if(_country.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destCountry:  _country[0] });

      if(_port.length == 1)
      dropDownValues = Object.assign( dropDownValues, { destinationValue:  _port[0] });
    }
  }
    setDdValues({ ...dropDownValues });
  };

  const handleSearchClick = async () => {
    let payloadData = [
      {
        carrier: ddValues["carrier"]["value"] === "all" ? "" : ddValues["carrier"]['value'].split('-')[0],
        originGeo: ddValues["originGeo"]["value"],
        originValue: ddValues["originValue"]["value"],
        originCountry: ddValues["originCountry"]["value"],
        servType: ddValues["serviceType"]["value"] === "all" ? "" : ddValues["serviceType"]["value"],
        serviceLevel: ddValues["serviceLevel"]["value"] === "all" ? "" : ddValues["serviceLevel"]["value"],
        modeOfTransport: ddValues["mode"]["value"] === "99" ? "" : ddValues["mode"]["value"],
        destinationGeo: ddValues["destinationGeo"]["value"],
        destinationValue: ddValues["destinationValue"]["value"],
        destCountry: ddValues["destCountry"]["value"],
        primaryOwner: ddValues["primaryOwner"]["text"] === "Select Primary Owner..." ? "" : ddValues["primaryOwner"]["text"],
      },
    ];

    if(payloadData[0].originGeo == "" && payloadData[0].originValue == "" && payloadData[0].originCountry == "" ){
      setOriginGeoList(ddData["originDestgeoData"]);
      setOriginPortList(ddData["originDestPortData"]);
      setOriginCountryList(ddData["originDestCountryData"]);
    }

    if(payloadData[0].destinationGeo == "" && payloadData[0].destinationValue == "" && payloadData[0].destCountry == "" ){
      setDestinationGeoList(ddData["originDestgeoData"]);
      setDestinationPortList(ddData["originDestPortData"]);
      setDestinationCountryList(ddData["originDestCountryData"]);
    }
    
    onSearchClick(payloadData);
  };

  return (
    <MDBContainer fluid className="box-container">
      <MDBRow className="rowBtm">
        {/* Carrier */}
        <MDBCol md="1" className="col-label">
          <label>Carrier</label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            data={carrierList}
            textField="text"
            filterable={true}
            style={{ width: "100%" }}
            onFilterChange={(event) => {
              setCarrierList(filterData(event.filter, "carrier"));
            }}
            dataItemKey="value"
            defaultItem={ddDefaultValues["carrier"]}
            onChange={(event) => {
              setDdValues({ ...ddValues, carrier: event.target.value });
            }}
            value={ddValues["carrier"]}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>

        {/* Service Type / Commodity */}
        <MDBCol md="1" className="col-label">
          <label>Commodity </label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            style={{ width: "100%" }}
            dataItemKey="value"
            textField="valueText"
            filterable={true}
            data={serviceTypeList}
            onFilterChange={(event) => {
              setServiceTypeList(filterData(event.filter, "serviceType"));
            }}
            defaultItem={ddDefaultValues["serviceType"]}
            value={ddValues["serviceType"]}
            onChange={(event) => {
              setDdValues({ ...ddValues, serviceType: event.target.value });
            }}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>
         {/* Mode */}
         <MDBCol md="1" className="col-label">
          <label>Mode</label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            style={{ width: "100%" }}
            dataItemKey="value"
            textField="valueText"
            filterable={true}
            data={modeList}
            defaultItem={ddDefaultValues["mode"]}
            onFilterChange={(event) => {
              setModeList(filterData(event.filter, "mode"));
            }}
            value={ddValues["mode"]}
            onChange={(event) => {
              setDdValues({ ...ddValues, mode: event.target.value });
            }}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>
        {/* Service Level  */}
        <MDBCol md="1" className="col-label">
          <label>Service Level </label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            style={{ width: "100%" }}
            dataItemKey="value"
            textField="valueText"
            filterable={true}
            data={serviceLevelList}
            onFilterChange={(event) => {
              setServiceLevelList(filterData(event.filter, "serviceLevel"));
            }}
            defaultItem={ddDefaultValues["serviceLevel"]}
            value={ddValues["serviceLevel"]}
            onChange={(event) => {
              setDdValues({ ...ddValues, serviceLevel: event.target.value });
            }}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>
      </MDBRow>
      <MDBRow className="rowBtm">
        {/* Service Level  */}
        <MDBCol md="1" className="col-label">
          <label>Primary Owner </label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            style={{ width: "100%" }}
            dataItemKey="text"
            textField="text"
            filterable={true}
            data={PrimaryOwnerList}
            onFilterChange={(event) => {
              setPrimaryOwnerList(filterData(event.filter, "primaryOwner"));
            }}
            defaultItem={ddDefaultValues["primaryOwner"]}
            value={ddValues["primaryOwner"]}
            onChange={(event) => {
              setDdValues({ ...ddValues, primaryOwner: event.target.value });
            }}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>

        {/* originValue  */}
        <MDBCol md="1" className="col-label">
          <label>Origin Port</label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            style={{ width: "100%" }}
            filterable={true}
            data={originPortList}
            dataItemKey="value"
            textField="displayText"
            onFilterChange={(event) => {
              setOriginPortList(filterData(event.filter, "originDestPortData"));
            }}
            defaultItem={ddDefaultValues["originValue"]}
            value={ddValues["originValue"]}
            onChange={(e) => {
              ddPortChange(e.target.value, "originValue");
            }}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>

        {/* originCountry  */}
        <MDBCol md="1" className="col-label">
          <label>Origin Country / Region</label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            data={originCountryList}
            dataItemKey="value"
            textField="text"
            filterable={true}
            style={{ width: "100%" }}
            onFilterChange={(event) => {
              setOriginCountryList(filterData(event.filter, "originDestCountryData"));
            }}
            defaultItem={ddDefaultValues["originCountry"]}
            onChange={(e) => {
              ddCountryChange(e.target.value, "originCountry");
            }}
            value={ddValues["originCountry"]}
            // dataItemKey="value"
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>

        {/* originGeo */}
      <MDBCol md="1" className="col-label">
          <label>Origin Geo</label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            data={originGeoList}
            dataItemKey="value"
            textField="text"
            filterable={true}
            style={{ width: "100%" }}
            onFilterChange={(event) => {
              setOriginGeoList(filterData(event.filter, "originDestgeoData"));
            }}
            defaultItem={ddDefaultValues["originGeo"]}
            onChange={(e) => {
              ddGeoChange(e.target.value, "originGeo");
            }}
            value={ddValues["originGeo"]}
            // dataItemKey="value"
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>
        </MDBRow>

      <MDBRow className="rowBtm">
{/* destinationValue  */}
        <MDBCol md="1" className="col-label">
          <label style={{minWidth: "75px"}}>Destination Port</label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            style={{ width: "100%" }}
            filterable={true}
            data={destinationPortList}
            dataItemKey="value"
            textField="displayText"
            onFilterChange={(event) => {
              setDestinationPortList(filterData(event.filter, "originDestPortData"));
            }}
            defaultItem={ddDefaultValues["destinationValue"]}
            onChange={(e) => {
              ddPortChange(e.target.value, "destinationValue");
            }}
            value={ddValues["destinationValue"]}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>
        {/* destCountry */}
        <MDBCol md="1" className="col-label">
          <label style={{minWidth: "75px"}}>Destination Country / Region</label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            style={{ width: "100%" }}
            filterable={true}
            dataItemKey="value"
            textField="text"
            data={destinationCountryList}
            onFilterChange={(event) => {
              setDestinationCountryList(
                filterData(event.filter, "originDestCountryData")
              );
            }}
            defaultItem={ddDefaultValues["destCountry"]}
            onChange={(e) => {
              ddCountryChange(e.target.value, "destCountry");
            }}
            value={ddValues["destCountry"]}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>
        {/* destinationGeo */}
        <MDBCol md="1" className="col-label">
          <label style={{minWidth: "75px"}}>Destination Geo</label>
        </MDBCol>
        <MDBCol md="2">
          <DropDownList
            style={{ width: "100%" }}
            filterable={true}
            dataItemKey="value"
            textField="text"
            data={destinationGeoList}
            onFilterChange={(event) => {
              setDestinationGeoList(filterData(event.filter, "originDestgeoData"));
            }}
            defaultItem={ddDefaultValues["destinationGeo"]}
            onChange={(e) => {
              ddGeoChange(e.target.value, "destinationGeo");
            }}
            value={ddValues["destinationGeo"]}
          ></DropDownList>
          {/*filter={this.ClearParent}*/}
        </MDBCol>
        <div md="3"></div>
      </MDBRow>

      <MDBRow className="dropdownSubmitRow">
        <Button
          primary={true}
          className="dropdownSubmit"
          onClick={handleSearchClick}
        >
          Search
        </Button>
      </MDBRow>
      {/* <div>
        <pre>{JSON.stringify(ddData, null, 2)}</pre>
      </div> */}
    </MDBContainer>
  );
}

export default QualificationDropdowns;
